import InfoItem from "../../../../../components/common/InfoItem";
import { GetSingleUserDataType } from "../../../../../types/portal/user";
import EditButtonEmployee from "./EditButtonEmployee";

type Props = {
  data?: GetSingleUserDataType;
};

export default function EmergencyInfo({ data }: Props) {
  return (
    <div className="employee_info_item">
      <InfoItem title="Name">
        {data?.data?.member?.emergency_contract_person_name}
      </InfoItem>
      <InfoItem title="Mobile Number">
        {data?.data?.member?.emergency_contract_person_number}
      </InfoItem>
      <InfoItem title="Relationship">
        {data?.data?.member?.emergency_contract_person_relationship}
      </InfoItem>
      {data?.data?.status !== "invited" && (
        <EditButtonEmployee type="Emergency" />
      )}
    </div>
  );
}
